import { defineMessages } from 'react-intl';

import type { AccountError } from '@/graphql/saleor/api';
import { INTL_PREFIX } from '@/messages/const';

import { commonErrorCodeMessages, type FormattedError } from './common';

const intlPrefix = INTL_PREFIX.MY_ACCOUNT;

export const errors = defineMessages({
  accountAlreadyExist: {
    id: `${intlPrefix}.accountAlreadyExist`,
    defaultMessage: 'Account already exists.',
  },
});

export const getAccountSignUpErrorCodeMessage = (
  error: FormattedError<AccountError>,
) => {
  switch (error.code) {
    case 'UNIQUE':
      return errors.accountAlreadyExist;

    default:
      return commonErrorCodeMessages.unexpectedErrorOccurred;
  }
};
